"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _apolloClientPreset = require("apollo-client-preset");

var _apolloLinkHttp = require("apollo-link-http");

var _apolloLinkError = require("apollo-link-error");

var _apolloLinkRetry = require("apollo-link-retry");

var useApolloClient = function useApolloClient(uri) {
  var httpLink = (0, _apolloLinkHttp.createHttpLink)({
    uri: uri
  });
  var loggerLink = new _apolloClientPreset.ApolloLink(function (operation, forward) {
    console.log("GraphQL Request: ".concat(operation.operationName));
    operation.setContext({
      start: new Date()
    });
    return forward(operation).map(function (response) {
      // const responseTime = new Date() - operation.getContext().start;
      // console.log(`GraphQL Response took: ${responseTime}`);
      return response;
    });
  });
  var retryLink = new _apolloLinkRetry.RetryLink({
    delay: {
      initial: 100,
      max: 2000,
      jitter: true
    },
    attempts: {
      max: 5,
      retryIf: function retryIf(error, operation) {
        console.log('error occurred:', error);
        console.log('error operation:', operation); // const doNotRetryCodes = [500, 400];
        // return !!error && !doNotRetryCodes.includes(error.statusCode);

        return !!error;
      }
    }
  });
  var errorLink = (0, _apolloLinkError.onError)(function (_ref) {
    var graphQLErrors = _ref.graphQLErrors,
        networkError = _ref.networkError;
    if (graphQLErrors) graphQLErrors.forEach(function (_ref2) {
      var message = _ref2.message,
          locations = _ref2.locations,
          path = _ref2.path;
      console.log("[GraphQL error]: Message: ".concat(message, ", Location: ").concat(locations, ", Path: ").concat(path));
    });
    if (networkError) console.log("[Network error]: ".concat(networkError));
  });

  var links = _apolloClientPreset.ApolloLink.from([loggerLink, retryLink, errorLink, httpLink]);

  var client = new _apolloClientPreset.ApolloClient({
    link: links,
    cache: new _apolloClientPreset.InMemoryCache(),
    // connect to your application's Apollo Client in production
    connectToDevTools: true
  });
  return client;
};

var _default = useApolloClient;
exports.default = _default;

//# sourceMappingURL=useApolloClient.js.map